var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4089_11613)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 140C47.8109 140 20 112.186 20 78.0072C20 43.8285 47.8109 16 82 16C116.189 16 144 43.8142 144 78.0072C144 112.2 116.189 140 82 140Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.22 78.0012C137.22 108.499 112.498 133.222 81.986 133.222C51.4744 133.222 26.752 108.499 26.752 78.0012C26.752 47.5034 51.4744 22.7661 81.986 22.7661C112.498 22.7661 137.22 47.489 137.22 78.0012Z",
    fill: "url(#paint0_linear_4089_11613)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M137.22 78.0012C137.22 108.499 112.498 133.222 81.986 133.222C51.4744 133.222 26.752 108.499 26.752 78.0012C26.752 47.5034 51.4744 22.7661 81.986 22.7661C112.498 22.7661 137.22 47.489 137.22 78.0012Z",
    fill: "url(#paint1_linear_4089_11613)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4832 90.8C63.5702 90.8 59.2462 94.7793 58.8152 99.6779C58.3986 104.576 62.0331 108.556 66.9461 108.556C71.859 108.556 76.183 104.576 76.614 99.6779C77.0449 94.7793 73.3961 90.8 68.4832 90.8ZM67.3339 104.059C64.9062 104.059 63.1105 102.091 63.326 99.6779C63.5415 97.2501 65.6675 95.2964 68.0953 95.2964C70.523 95.2964 72.3187 97.2645 72.1032 99.6779C71.8878 102.091 69.7617 104.059 67.3339 104.059Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.033 76.8663L114.322 66.2646C113.274 65.1154 111.076 64.1673 109.438 64.1673H97.5868L98.3482 55.2895C98.4918 53.6662 97.2708 52.3302 95.6331 52.3302H53.2703C51.6327 52.3302 50.1962 53.6662 50.0525 55.2895L50.0094 55.8354H42.3528C41.376 55.8354 40.5284 56.6255 40.4422 57.5879C40.356 58.5504 41.0743 59.3405 42.0511 59.3405H71.471C72.4478 59.3405 73.166 60.1306 73.0798 61.0931C72.9937 62.0556 72.1461 62.8457 71.1693 62.8457H35.3282C34.3514 62.8457 33.5038 63.6358 33.4177 64.5983C33.3315 65.5608 34.0497 66.3508 35.0266 66.3508H64.7337C65.7105 66.3508 66.4288 67.1409 66.3426 68.1034C66.2564 69.0659 65.4089 69.856 64.432 69.856H38.8333C37.8565 69.856 37.0089 70.6461 36.9228 71.6086C36.8366 72.571 37.5548 73.3611 38.5317 73.3611H73.2091C74.1716 73.3611 74.9042 74.1512 74.818 75.1137C74.7318 76.0762 73.8843 76.8663 72.9075 76.8663H42.6257C41.6489 76.8663 40.8013 77.6564 40.7152 78.6189C40.629 79.5814 41.3472 80.3715 42.3241 80.3715H57.9821C58.9589 80.3715 59.6772 81.1616 59.591 82.1241C59.5048 83.0865 58.6572 83.8766 57.6804 83.8766H47.5817L46.4756 96.7049C46.3319 98.3282 47.553 99.6642 49.1906 99.6642H56.603C57.1345 93.5446 62.5502 88.5741 68.6841 88.5741C74.818 88.5741 79.3718 93.5589 78.8403 99.6642H97.4862C98.0178 93.5446 103.433 88.5741 109.567 88.5741C115.701 88.5741 120.255 93.5589 119.724 99.6642H121.203C122.826 99.6642 124.277 98.3282 124.421 96.7049L125.699 81.9086C125.843 80.2853 125.096 78.0156 124.033 76.852V76.8663ZM99.3968 77.484L100.287 67.1266H109.179C110.027 67.1266 111.492 67.7586 112.038 68.3476L120.399 77.484H99.3968Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.366 90.8C104.453 90.8 100.129 94.7793 99.6985 99.6779C99.2819 104.576 102.916 108.556 107.829 108.556C112.742 108.556 117.066 104.576 117.497 99.6779C117.914 94.7793 114.279 90.8 109.366 90.8ZM108.217 104.059C105.789 104.059 103.994 102.091 104.209 99.6779C104.425 97.2501 106.551 95.2964 108.979 95.2964C111.406 95.2964 113.202 97.2645 112.987 99.6779C112.771 102.091 110.631 104.059 108.217 104.059Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4089_11613",
    x: 0,
    y: 0,
    width: 164,
    height: 164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4089_11613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4089_11613",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4089_11613",
    x1: 82.0003,
    y1: 22.7661,
    x2: 82.0003,
    y2: 133.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80BC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4089_11613",
    x1: 82.0003,
    y1: 22.7661,
    x2: 82.0003,
    y2: 133.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80BC00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.f652d70c076e20d5e10c732cf1581084.svg";
export { ForwardRef as ReactComponent };